import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Column, Row } from '../../globalStyles';

export const FooterContainer = styled.div`
	background-color: #04403e;
	padding: 4rem 0 2rem 0;
`;

export const FooterWrapper = styled.div`
	max-width: 1280px;
	margin-left: auto;
	margin-right: auto;
`;

export const FooterSubscription = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	margin-bottom: 24px;
	padding: 24px;
	color: #fff;
`;

export const FooterSubHeading = styled.p`
	font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial,
		sans-serif;
	margin-bottom: 24px;
	font-size: 24px;
`;

export const FooterRow = styled(Row)`
	flex-wrap: wrap;
	@media screen and (max-width: 820px) {
		> div {
			width: 20%;
		}
		> div:first-child {
			width: 100%;
		}
	}
	@media screen and (max-width: 420px) {
		flex-direction: column;
		align-items: center;
		* {
			width: 100%;
			text-align: center;
		}
	}
`;

export const FooterGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(300px, 450px) 300px;
	gap: 2rem;
	justify-content: space-between;
	align-items: start;
	padding: 0 1rem;

	@media screen and (max-width: 1000px) {
		grid-template-columns: 1fr;
		gap: 2rem;
	}
`;

export const FooterColumn = styled(Column)`
	gap: 1rem;

	@media screen and (max-width: 999px) {
		align-items: center;
		grid-column: 1/-1;
		text-align: center;
	}
`;

export const FooterSubText = styled.p`
	margin-bottom: 24px;
	font-size: 20px;
`;

export const FooterLinksContainer = styled.div`
	width: 100%;
	max-width: 1000px;
	display: flex;
	justify-content: center;
	@media screen and (max-width: 820px) {
		padding-top: 32px;
	}
`;

export const FooterLinkItems = styled.div`
	display: flex;
	flex-direction: column;
	text-align: left;
	box-sizing: border-box;
	color: #fff;
	margin-right: 1.5rem;

	@media screen and (max-width: 1000px) {
		align-items: center;
		text-align: center;
		margin-right: 0;
		margin-bottom: 0.5rem;
	}
`;

export const FooterLinkTitle = styled.h3`
	margin: 0;
	font-size: 1rem;
	font-weight: 500;
	line-height: 1.2;
	&:hover {
		color: #18776a;
		transition: 0.3s ease-out;
	}
`;

export const FooterLink = styled(Link)`
	color: #fff;
	text-decoration: none;
	margin-bottom: 0.5rem;
	&:hover {
		color: #18776a;
		transition: 0.3s ease-out;
	}
`;

export const FooterLogo = styled(Link)`
	color: #fff;
	justify-self: start;
	cursor: pointer;
	text-decoration: none;
	font-size: 2rem;
	display: flex;
	align-items: center;
	margin-bottom: 16px;
`;

export const SocialIcon = styled.img`
	margin-right: 10px;
	width: 40px;
`;

export const FooterRights = styled.div`
	color: #fff;
	margin-bottom: 16px;
	width: 100%;
	font-size: 0.8rem;
	text-align: center;
	border-top: 1px solid #066a67;
	padding: 1rem 0;
	margin: 1rem 0 0;
`;

export const FooterSocialIcon = styled.a`
	color: #fff;
	font-size: 24px;
`;

export const FooterAddress = styled.div`
	color: white;
	margin-bottom: 0.75rem;
	font-weight: 500;
	font-size: 0.875rem;
	line-height: 1.5;
	text-align: left;
	padding-left: 0.5rem;
	border-left: 2px solid #066a67;

	@media screen and (max-width: 1000px) {
		text-align: center;
		border-left: none;
		padding-left: 0;
	}
`;

export const FooterMap = styled.div`
	width: 100%;
	height: 100%;
	min-height: 250px;
	
	iframe {
		width: 100%;
		height: 100%;
		min-height: 250px;
		border: 0;
		border-radius: 8px;
	}
	
	@media screen and (max-width: 768px) {
		min-height: 200px;
		
		iframe {
			min-height: 200px;
		}
	}
`;